import { offerOrderClient } from '@/api/clients';
import { ORDERS } from '@/store/entities/schema_types';

export default function makeOfferOrderModule(offerId) {
  return {
    namespaced: true,
    state: {
      fetching: false,
      orderId: null,
    },
    mutations: {
      SET_FETCHING(state, payload) {
        state.fetching = Boolean(payload.fetching);
      },
      SET_ORDER_ID(state, payload) {
        state.orderId = payload.orderId;
      },
    },
    actions: {
      async fetchOrder(ctx, { params = {} } = {}) {
        try {
          const response = await offerOrderClient.list(offerId, { params });

          const { data } = response.data;

          if (data === null) {
            return Promise.resolve(true);
          }

          const orderId = await ctx.dispatch(
            'entities/persistEntities',
            { type: ORDERS, data },
            { root: true }
          );

          ctx.commit({
            type: 'SET_ORDER_ID',
            orderId,
          });

          return Promise.resolve(true);
        } catch (error) {
          return Promise.reject(error);
        }
      },
      async storeOrder(ctx) {
        if (ctx.state.orderId !== null) {
          return Promise.resolve(ctx.state.orderId);
        }

        try {
          const response = await offerOrderClient.store(offerId);

          const { data } = response.data;

          const orderId = await ctx.dispatch(
            'entities/persistEntities',
            { type: ORDERS, data },
            { root: true }
          );

          ctx.commit({
            type: 'SET_ORDER_ID',
            orderId,
          });

          return Promise.resolve(orderId);
        } catch (error) {
          return Promise.reject(error);
        }
      },
    },
  };
}
